import { trackingService } from '@monthio/react-components'
import {
	sendMixpanelTelemetry,
	sendTelemetry,
} from '../api/statisticsReportApi'

const flattenObj = (
	obj: Record<string, any>,
	parent?: string,
	res: Record<string, any> = {},
) => {
	for (const key of Object.keys(obj)) {
		const propName = parent ? parent + '.' + key : key
		if (typeof obj[key] === 'object' && obj[key] !== null) {
			flattenObj(obj[key], propName, res)
		} else {
			res[propName] = obj[key]
		}
	}
	return res
}

interface ApplicantData {
	applicantId: string | null
	applicantConsumerId?: string
	applicantSessionId?: string
	partOfMultiFlow?: boolean
	isFinalFlow?: boolean
	clientId?: number
}

class StatisticsReportTelemetryService {
	private additionalEventData?: ApplicantData
	public initialize() {
		trackingService.events.subscribe((event) => {
			this.sendMixpanelTelemetry(event.eventName, event.additional ?? {})
			sendTelemetry({
				additionalData: {
					additional: event.additional,
					options: event.options,
					applicantData: this.additionalEventData,
					type: 'event',
				},
				eventName: event.eventName,
			})
		})
		trackingService.technicalEvents.subscribe((event) =>
			sendTelemetry({
				additionalData: {
					additional: event.additional,
					options: event.options,
					applicantData: this.additionalEventData,
					type: 'technicalEvent',
				},
				eventName: event.eventName,
			}),
		)
		trackingService.errors.subscribe((event) =>
			sendTelemetry({
				additionalData: {
					additional: event.additional,
					options: event.options,
					applicantData: this.additionalEventData,
					error: event.error,
					type: 'error',
				},
				eventName: 'error',
			}),
		)
	}

	public setApplicantData(applicantData: ApplicantData) {
		this.additionalEventData = applicantData
	}

	private sendMixpanelTelemetry(eventName: string, additionalData: any) {
		let enrichedAdditionalData = additionalData

		if (this.additionalEventData != null) {
			enrichedAdditionalData = {
				...this.additionalEventData,
				...additionalData,
			}
		}

		return sendMixpanelTelemetry({
			eventName,
			// Mixpanel doesn't support nested object
			additionalData: flattenObj(enrichedAdditionalData),
		})
	}
}

export const statisticsReportTelemetryService =
	new StatisticsReportTelemetryService()
